import React from "react"
import { CircularProgress } from "@mui/material"

function Loader() {
  return (
    <div className="min-h-screen flex justify-center items-center"><CircularProgress /></div>
  )
}

export default Loader